import useSingleSetting from "../data/useSingleSetting";

/**
 * The fields a part's history is allowed to show, as a JSON array. Read by the editor on
 * Admin > Part History Fields and by PartHistoryService.ResolveHistoryFields on the API side.
 */
export const HISTORY_FIELDS_KEY = "Part:HistoryFields";

/**
 * Whether Part History is set up for this customer, which is simply whether Part:HistoryFields
 * exists. No separate on/off flag - the setting the feature already runs on is the switch.
 *
 * Absent means the customer was never set up for it, so the surfaces this release added stay
 * hidden: the history card on the Active Listings expanded row, and Admin > Part History Fields.
 * The Stock page's history drawer is deliberately not gated - it has been live since August.
 *
 * Also false while the setting is in flight, so nothing appears and then vanishes.
 */
export default function usePartHistoryEnabled() {
  const { singleSetting } = useSingleSetting(HISTORY_FIELDS_KEY);

  // Presence, not value. An absent setting 404s and useSingleSetting resolves that as null.
  return !!singleSetting.data?.data;
}
